import { useEffect, useMemo } from "react"
import { useDispatch } from "react-redux"
import { getTotalJobCount } from "../Actions/API/AppInstance/AppInstanceActions"
import { UserPlan } from "../Models/API/UserModel"
import { getValue, hasValue } from "../Models/Client/FetchState"
import { useAppInstance } from "./useAppInstance"
import { useAppState } from "./useReduxState"
import { useUserPlan } from "./useUserPlan"

export const FREEMIUM_JOB_LIMIT = 1000
/**
 * Helps in getting all jobs count inculding deleted and relabeled
 */
export const useCanUploadJobs = (
    appID: string
): {
    upload_allowed: boolean
    remaining_count: number | undefined
} => {
    const dispatch = useDispatch()
    const totalJobCount = useAppState(
        state => state.api.apps.totalJobCount[appID]
    )

    const userPlan = useUserPlan()
    const instanceFetch = useAppInstance(appID)
    const batchCount = getValue(instanceFetch)?.batchProcessCount

    useEffect(() => {
        if (userPlan === UserPlan.FREEMIUM && totalJobCount === undefined) {
            dispatch(getTotalJobCount(appID))
        }
    }, [appID, dispatch, totalJobCount, userPlan])

    useEffect(() => {
        // this should be triggered on change of batchJobProcessCount
        if (userPlan === UserPlan.FREEMIUM && batchCount === 0) {
            dispatch(getTotalJobCount(appID))
        }
    }, [appID, batchCount, dispatch, userPlan])

    return useMemo(() => {
        const remaining_count = FREEMIUM_JOB_LIMIT - (totalJobCount ?? 0)
        return {
            upload_allowed:
                userPlan === UserPlan.FULL ||
                (hasValue(instanceFetch) &&
                    instanceFetch.value.batchProcessCount <= 0 &&
                    userPlan === UserPlan.FREEMIUM &&
                    totalJobCount !== undefined &&
                    remaining_count > 0),
            remaining_count:
                userPlan === UserPlan.FULL
                    ? undefined
                    : remaining_count < 0
                    ? 0
                    : remaining_count
        }
    }, [instanceFetch, totalJobCount, userPlan])
}
